import api from "./api";
import { normalizeOptionCalories } from '../utils/calories';

const resource = "Option/";

// Option

export const list = async (optiongroupid) => {
  return await api.get(
    resource + "List/Option?optiongroupid=" + optiongroupid + "&pageSize=100"
  );
};

export const getById = async (id) => {
  return await api.get(resource + "Get/Option?id=" + id);
};

export const upsert = async (body) => {
  return await api.post(resource + "Upsert/Option", normalizeOptionCalories(body));
};

export const deleteById = async (id) => {
  return await api.delete(resource + "Delete/Option?id=" + id);
};

// Option Group

export const groupList = async (query) => {
  return await api.get(resource + `List/OptionGroup` + query);
};

export const getGroupById = async (id) => {
  return await api.get(resource + "Get/OptionGroup?id=" + id);
};

export const upsertGroup = async (body) => {
  return await api.post(resource + "Upsert/OptionGroup", body);
};

export const duplicateGroup = async (id) => {
  return await api.post(resource + 'Duplicate/OptionGroup?id=' + id);
};

export const deleteGroupById = async (id) => {
  return await api.delete(resource + "Delete/OptionGroup?id=" + id);
};

export const reorderGroup = async (body) => {
  return await api.post(resource + 'Reorder/OptionGroup', body);
};

export const reorderOption = async (body) => {
  return await api.post(resource + 'Reorder/Option', body);
};

const optionApi = {
  list,
  getById,
  upsert,
  deleteById,
  groupList,
  getGroupById,
  upsertGroup,
  duplicateGroup,
  deleteGroupById,
  reorderGroup,
  reorderOption,
};

export default optionApi;
